import { defaultDataGridProps } from '@cw-ui/data-grid';

export const DATA_GRID_DEFAULTS = {
    ...defaultDataGridProps,
    sx: {
        '& .toolbar': {
            margin: '0 0 8px 0',
        },
    },
};

export const EDIT_PRODUCT_DRAWER = 'EDIT_PRODUCT_DRAWER';
export const GENERATE_TOKEN_DIALOG = 'GENERATE_TOKEN_DIALOG';
export const DELETE_PRODUCT_INSTANCE_DIALOG = 'DELETE_PRODUCT_INSTANCE_DIALOG';
export const EDIT_PRODUCT_INSTANCE_DIALOG = 'EDIT_PRODUCT_INSTANCE_DIALOG';
